import { StepShell } from '../components/layout';
import { SkillPicker, SkillRow, SelectionCounter } from '../components/selection';
import { Note } from '../components/inputs';

const MIN_SKILLS = 3;

export default function SkillsStep({ data, update, notes = {}, config }) {
  const skills = data.skills || [];

  const add = (skill) => {
    if (skills.some((s) => s.skill_name.toLowerCase() === skill.skill_name.toLowerCase())) return;
    update({ skills: [...skills, skill] });
  };

  const patch = (index, next) => {
    update({ skills: skills.map((s, i) => (i === index ? next : s)) });
  };

  const remove = (index) => {
    update({ skills: skills.filter((_, i) => i !== index) });
  };

  return (
    <StepShell
      eyebrow="Step 4 of 18"
      title="Skills you’re building"
      lede="Pick anything you can do — including the things you are still learning. Being early in something is not a weakness, it is just where you are."
      why="This is the single most useful section for matching you to work you can actually get stuck into from week one."
      encouragement="Most people underestimate this section. Speaking two languages is a skill. Organising an event is a skill. Explaining things clearly is a skill."
    >
      {skills.length > 0 && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 12 }}>
            <span className="ob-group-label" style={{ marginBottom: 0 }}>Your skills</span>
            <SelectionCounter count={skills.length} min={MIN_SKILLS} />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {skills.map((skill, index) => (
              <SkillRow
                key={skill.skill_name}
                skill={skill}
                levels={config.proficiencyLevels}
                onChange={(next) => patch(index, next)}
                onRemove={() => remove(index)}
              />
            ))}
          </div>

          {notes.skills && <div style={{ marginTop: 12 }}><Note>{notes.skills}</Note></div>}
        </div>
      )}

      <div className="ob-divider">
        <div className="ob-group-label">
          {skills.length > 0 ? 'Add more' : `Add at least ${MIN_SKILLS} to continue`}
        </div>
        <SkillPicker catalog={config.skillCatalog} chosen={skills} onAdd={add} />
      </div>
    </StepShell>
  );
}
